<template>

    <div class="space-y-6">

        <div class="space-y-1">
            <p class="text-sm">
                This is Partnero front-end integration. Using this example, you can create customers and assign transactions to them using simple front-end JavaScript calls.
            </p>
        </div>

        <div class="space-y-4">
            <div class="space-y-2">
                <h3 class="text-md font-semibold">
                    1. Send sign-up data
                </h3>
                <div class="space-y-1">
                    <p class="text-sm">
                        Using this method, you need to set the values to represent the customer’s details.
                    </p>
                    <p class="text-sm">
                        Immediately after a user successfully signs up, run this script with the required values to ensure proper tracking.
                    </p>
                    <p class="text-sm">
                        Please note that while creating a customer you have to replace <b>key</b>, <b>name</b> and <b>email</b> with a real data from your platform.
                    </p>
                </div>
            </div>
            <div class="relative">
                <code-snippet :code="customerExample" language="javascript" />
            </div>
        </div>

        <div class="space-y-4">
            <div class="space-y-2">
                <h3 class="text-md font-semibold">
                    2. Send sales data
                </h3>
                <div class="space-y-1">
                    <p class="text-sm">
                        This method allows you to send transaction data via JavaScript calls. Please note that this method is not fully secure and is disabled by default. We recommend using the API or Payment Gateway instead. To use this method, it must be enabled on your program’s Integration page.
                    </p>
                    <p class="text-sm">
                        Execute this script immediately following a successful sale.
                    </p>
                </div>
            </div>
            <div class="relative">
                <code-snippet :code="transactionExample" language="javascript" />
            </div>

        </div>

    </div>

</template>

<script setup>

const transactionExample = `<script>
    po('transactions', 'create', {
        data: {
            key: 'transaction_123',
            amount: 99.99,
            amount_units: 'usd',
            product_id: 'prod_123', // optional
            product_type: 'monthly', // optional
            customer: {
                key: 'customer_123456'
            }
        }
    });
</scr` + `ipt>`

const customerExample = `<script>
    po('customers',
        'signup', {
            data: {
                key: 'customer_123456', // or email address
                name: 'John',
                email: 'john.doe@partnero.com'
            }
        }
    );
</scr` + `ipt>`

</script>

<style scoped>

</style>
